/**
 * <Form />
 *
 * This is a wrapper for react-jsonschema-form. It provides extra functionalities 
 * and predefines some values.
 *
 * 1. One of the critical function is a callback function getSubmitButton() that 
 * passes the ref of a submit button which you call to trigger 'form submit.'
 *
 * 2. It provides custom widgets: 'datepicker', 'money', 'reactselect'
 *
 * 3. When you define uiSchema, you can pass a array of uiSchemas which will
 * wrapped in <section className={classNames}/>
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import JsonSchemaForm from 'vendor/react-jsonschema-form';
import Joi from 'joi-browser';

import Loading from 'components/UI/Loading'
import './Form.scss';
import section from 'vendor/react-jsonschema-form-section';
import SelectStudentModal from 'template/Modals/SelectStudent';
import SelectClassroomModal from 'template/Modals/SelectClassroom';

import widgets from './widgets';

const fields = {
  section: section
}

//
// REFACTOR IT
//

class Form extends React.Component {
  static propTypes = {
  }

  constructor(props) {
    super(props);

    this._validate = this._validate.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this._convertJoiResultToErrors = this._convertJoiResultToErrors.bind(this);
    this._transformErrors = this._transformErrors.bind(this);

    this.state = {
      formData: this.props.formData || {}
    }
  }

  componentWillReceiveProps({ formData }) {
    if (formData) {
      this.setState({
        formData,
      });
    }
  }

  componentDidMount() {
  }

  _onFormChange({ formData }) {
    let {
      onChange
    } = this.props;

    this.setState({
       formData,
    }, ()=>{
      if (typeof onChange == 'function') {
        onChange(this.state.formData);
      } 
    });

  }

  _transformErrors(errors, schema) {
    return errors.map(error => {
      let name = error.property.replace('.', '');
      
      if (error.name === "required") {
        error.message = __('Please fill this field', 'form.errorMessage');
      }

      if (error.params && error.params.format == 'email') {
        error.message = __('Please enter a correct email', 'form.errorMessage');
      }
     
      return error;
    });
  }

  
  _validate(formData, errors) {
    return errors;
  } 

  _convertJoiResultToErrors(errorDetails, errors) {
    errorDetails.forEach((errorItem)=>{
      if (errorItem.type == 'any.required') {
        return;
      }

      const { key } = errorItem.context;

      if (errors[key]) {
        errors[key].addError(errorItem.type);
      }
    });

    return errors;
  }
  
  render() {

    const {
      schema,
      className,
      getSubmitButton = function(){},
      uiSchema,
      onChange,
      fetching,
    } = this.props;

    const formData = this.state.formData;

    const {
      validationError
    } = this.state;

    const uiSchemaSection = Array.isArray(uiSchema) ? uiSchema : [uiSchema]; 

    return (
      <div className={classnames('classtop-form', ...className, { 'validation-error': validationError, 'fetching': fetching  })} >
        { fetching === true && <Loading /> }
        <JsonSchemaForm 
          {...this.props}
          formData={formData}
          uiSchema={{
            'ui:field': 'section',
            'ui:section': uiSchemaSection,
          }}
          onChange={this._onFormChange}
          noHtml5Validate={true} 
          showErrorList={false}
          fields={fields}
          widgets={widgets}
          transformErrors={(errors)=>{ return this._transformErrors(errors, schema)}}
          ref={(r)=>{this.formRef = r}}
        >
          {this.props.children}
          <button type="submit" style={{display: 'none'}} ref={(r)=>{ getSubmitButton(r) }} >Submit</button>
        </JsonSchemaForm> 
      </div>  
    )
  }
}

export default Form;






// WEBPACK FOOTER //
// ./src/components/UI/Form/index.js